// @flow

import React from 'react';
import styled, { css } from 'styled-components';

import { colors, fontWeight } from 'seedling/constants';

import type { Node } from 'react';

export type DataTableProps = {
  fixed: boolean,
  width: string,
  collapse: boolean,
};

const DataTable = styled.table`
  table-layout: ${props => (props.fixed ? 'fixed' : 'auto')};
  border: 1px solid ${colors.lightGrey};
  background-color: ${colors.white};
  width: ${props => props.width || '100%'};
  border-radius: 3px 3px 0 0;
  border: 1px solid ${colors.lightGrey};
  border-collapse: ${props => (props.collapse ? 'collapse' : 'seperate')};

  th {
    box-sizing: border-box;
    padding: 7px 15px;
    background-color: ${colors.lightestGrey};
    border-right: solid 1px ${colors.lightGrey};
    text-align: left;
    color: ${colors.darkGrey};
    font-size: 12px;
    font-weight: ${fontWeight.heavy};

    &:first-child {
      border-radius: 3px 0 0 0;
    }

    &:last-child {
      border-radius: 0 3px 0 0;
      border-right: none;
    }
  }

  td {
    box-sizing: border-box;
    padding: 10px 15px;
    height: 60px;
    border-top: solid 1px ${colors.lightGrey};
    font-size: 14px;
    font-weight: ${fontWeight.normal};
  }
`;

DataTable.displayName = 'DataTable';

const TableHeader = styled.th`
  width: ${props => props.width};
`;

const SortableStyles = styled<{ sortDirection: ?string }>(TableHeader)`
  ${props =>
    props.sortDirection === 'asc' &&
    css`
      box-shadow: inset 0 3px 0 0 rgba(0, 0, 0, 0.6);
    `}

  ${props =>
    props.sortDirection === 'desc' &&
    css`
      box-shadow: inset 0 -3px 0 0 rgba(0, 0, 0, 0.6);
    `}
`;

type Props = {
  onChange: () => void,
  width: string,
  children?: Node,
  sortDirection: ?string,
};

const SortableTableHeader = ({
  width,
  children,
  sortDirection,
  onChange,
}: Props) => {
  return (
    <SortableStyles
      width={width}
      sortDirection={sortDirection}
      onClick={onChange}
    >
      {children}
    </SortableStyles>
  );
};

export default DataTable;

export { TableHeader, SortableTableHeader };
